import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class EventBusService {
  private navigationLoaderSubject = new BehaviorSubject<boolean>(false);

  // Navigation loader events
  setNavigationLoading(isLoading: boolean) {
    this.navigationLoaderSubject.next(isLoading);
  }

  getNavigationLoaderObservable() {
    return this.navigationLoaderSubject.asObservable();
  }
}
